module.exports = "/MessageActive@2x-79a62c3e4ce716abce9e9926d3a600be.png";